import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/poles/poleCardView.css';

const PoleGridData = React.memo(({ index, style, data }) => {

    const { poles, columns, filteredPoleCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredPoleCount);

    const handlePoleClick = useCallback((poleId) => navigate(`pole_details/${poleId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const poleIndex = startIndex + idx;
                const pole = poles[poleIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={pole ? pole.id : `skeleton-${poleIndex}`}>
                        <Card className='poles_gridview_card'>
                            <CardActionArea onClick={pole ? () => handlePoleClick(pole.id) : undefined}>
                                {pole ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(pole, 'pole', { size: 'small', fallback: machineDefaultImage })}
                                            alt={pole?.name}
                                        />
                                        <CardContent className='poles_gridview_card_CardContent'>
                                            <Typography className='poles_gridview_pole_name' component="div">{pole?.name}</Typography>
                                            <Typography className='poles_gridview_pole_adress' component="div">{pole?.description || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default PoleGridData;